// TOTP via Web Crypto API — RFC 6238 (Google Authenticator compatible)
// Zero dependências externas.

const B32 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

function base32Decode(str) {
  const s = str.toUpperCase().replace(/=+$/, '').replace(/[^A-Z2-7]/g, '');
  const bytes = [];
  let buffer = 0, bitsLeft = 0;
  for (const c of s) {
    const val = B32.indexOf(c);
    if (val < 0) continue;
    buffer = (buffer << 5) | val;
    bitsLeft += 5;
    if (bitsLeft >= 8) { bytes.push((buffer >> (bitsLeft - 8)) & 0xff); bitsLeft -= 8; }
  }
  return new Uint8Array(bytes);
}

function base32Encode(bytes) {
  let result = '', buffer = 0, bitsLeft = 0;
  for (const byte of bytes) {
    buffer = (buffer << 8) | byte;
    bitsLeft += 8;
    while (bitsLeft >= 5) { result += B32[(buffer >> (bitsLeft - 5)) & 31]; bitsLeft -= 5; }
  }
  if (bitsLeft > 0) result += B32[(buffer << (5 - bitsLeft)) & 31];
  return result;
}

export function generateSecret(length = 20) {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return base32Encode(bytes);
}

export function getOtpAuthUrl(email, secret) {
  const issuer = 'Rodrigo Demeterco Advocacia';
  const params = new URLSearchParams({ secret, issuer, algorithm: 'SHA1', digits: '6', period: '30' });
  return `otpauth://totp/${encodeURIComponent(issuer + ':' + email)}?${params}`;
}

async function hmacSha1(keyBytes, counter) {
  const data = new ArrayBuffer(8);
  const view = new DataView(data);
  view.setUint32(0, Math.floor(counter / 0x100000000), false);
  view.setUint32(4, counter >>> 0, false);
  const key = await crypto.subtle.importKey('raw', keyBytes, { name: 'HMAC', hash: 'SHA-1' }, false, ['sign']);
  return new Uint8Array(await crypto.subtle.sign('HMAC', key, data));
}

async function generateTOTP(secret, timeStep) {
  const mac = await hmacSha1(base32Decode(secret), timeStep);
  const offset = mac[19] & 0x0f;
  const code = (((mac[offset] & 0x7f) << 24) | ((mac[offset+1] & 0xff) << 16) | ((mac[offset+2] & 0xff) << 8) | (mac[offset+3] & 0xff)) % 1_000_000;
  return String(code).padStart(6, '0');
}

export async function verifyToken(token, secret) {
  const raw = String(token).replace(/\D/g, '');
  const step = Math.floor(Date.now() / 1000 / 30);
  for (const delta of [0, -1, 1]) {
    const expected = await generateTOTP(secret, step + delta);
    if (expected === raw) return true;
  }
  return false;
}

// PIN de 4 dígitos — SHA-256 via Web Crypto
export async function hashPin(pin) {
  const encoder = new TextEncoder();
  const data = encoder.encode(String(pin).replace(/\D/g, ''));
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer)).map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function verifyPin(entered, storedHash) {
  if (!storedHash) return false;
  const enteredHash = await hashPin(String(entered).replace(/\D/g, ''));
  return enteredHash === storedHash;
}
